<script>
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {PaginationMixin} from "@/mixins/PaginationMixin";
import {permissionMixin} from "@/mixins/permissionMixins";
import attachmentMixin from "@/mixins/attachmentMixin";
import AppLoading from "@/components/elements/AppLoading.vue";
import NewRsInspectionReport from "@/components/layouts/NewRsInspectionReport";
import {mapActions, mapGetters} from "vuex";
import {AlertService} from "@/services/AlertService";
import RsncQuestionComponent from "@/components/modules/rightship/RsncQuestionComponent.vue";
import TableColumnSearch from "@/components/common/TableColumnSearch.vue";
import en from "vue2-datepicker/locale/es/en";

export default {
  name: "RsIndex",
  mixins: [vueAppMixin, PaginationMixin, permissionMixin, attachmentMixin],
  data() {
    return {
      filters: {
        page: 1,
        count: 30,
        fleet_id: null,
        status_id: null,
        office_id: null,
        flag_id: null,
        company_id: null,
        category:'inspection_commencement_date',
        order_position:'desc',
        vessel_name: null,
        manager_name: null,
        title: null,
        report_status: null,
        no_of_def: null,
        non_conformity_count: null,
        no_of_obs: null,
        no_of_rec: null,
        fleet: null,
        port_name: null,
        country: null,
        inspection_date: null,
        inspector_name: null,
        company: null,
        responsible_person: null,
        person_in_charge: null,
        created_by: null,
      },
      loading: false,
      listOfFindings: [],
      reportStatusInitial:[
        {
          id:1,
          name:'In Progress',
          background: 'bg-ffbf00'
        },
        {
          id:2,
          name:'Ready to Close',
          background: 'bg-042454'
        },
        {
          id:3,
          name:'Closed',
          background: 'bg-4c4c4c'
        },
        {
          id:4,
          name:'Withdraw',
          background: 'bg-c75912'
        },
      ]
    }
  },
  components: {
    TableColumnSearch,
    RsncQuestionComponent,
    'new-rs-inspection-report': NewRsInspectionReport,
    'loading': AppLoading,
    DatePicker: () => import('vue2-datepicker')
  },
  methods: {
    ...mapActions([
      'addRequestKeys',
      'generateRequestKeys',
      'getRsReports',
      'deleteRs',
      'downloadRsList',
    ]),

    setPage(page = null) {
      page = page ? page : this.filters.page;
      localStorage.setItem('accidentIncidentPage', page);
      this.pagination.currentPage = page;
      this.filters.page = page
      this.getRsReports(this.filters);
    },

    showRsInspection(inspectionId) {
      this.$router.push(
        {
          name: 'RsMain',
          params: {
            id: inspectionId
          }
        }
      );
    },
    showRsInspectionOnNewTab(inspectionId) {
      const route= this.$router.resolve(
        {
          name: 'RsMain',
          params: {
            id: inspectionId,
          },
        },
      )
      window.open(route.href,'_blank')
    },

    async verifyDelete(rs) {
      if (await AlertService.confirmDeleteAlert('Delete Rightship Inspection', 'Do you want to delete this inspection?', 'Yes Proceed')) {
        const params = {type: 1, id: rs.id}
        const response = await this.deleteRs(params);

        if (response) {
          AlertService.successAlert('Inspection successfully deleted', 'DELETE RIGHTSHIP');
          this.setPage(1);
        }
      }
    },

    viewListOfFindings(data){
      this.listOfFindings = data.non_conformity;
    },

    closeModal(){
      this.listOfFindings = [];
    },
    async setVesselsToTable(){
      this.loading = true
      this.filters.page = 1
      await this.getRsReports(this.filters);
      this.loading = false
    },
    async applyFilter(key, value) {
      this.filters[key] = value
      this.filters.page = 1

      this.loading = true
      try {
        await this.getRsReports(this.filters)
      } finally {
        this.loading = false
      }
    },
    async downloadReport(fileType){
      this.filters.fileType = fileType

      swal.fire({
        'title': `GENERATING RIGHTSHIP LIST ${fileType === 'pdf' ? 'PDF' : 'EXCEL'} REPORT <br>Please wait.....`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()
      let response = await this.downloadRsList(this.filters);
      swal.close();
      if (response === false) {
        return AlertService.errorAlert('Theres an error downloading the ' + fileType.toUpperCase() + ' file. Please try again later!', 'DOWNLOADING FILE');
      }
      let mime_type = fileType === 'pdf' ? 'application/pdf' : 'application/vnd.ms-excel'
      let url = window.URL.createObjectURL(new Blob([response],{type:mime_type}))

      fileType = (fileType !== 'pdf') ? 'xlsx' : 'pdf';

      let filename=`RIGHTSHIP_LIST_REPORT.${fileType}`;

      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    sortByCategory(column){
      this.filters.category = column;
      this.filters.order_position = this.filters.order_position == 'desc' ? 'asc' : 'desc';
      this.applyFilter('category', column)
    }
  },
  computed: {
    ...mapGetters([
      // 'isLoading', 'vesselKeys', 'fleetKeys',
      'isLoading', 'reports', 'vesselKeys', 'fleetKeys', 'portKeys',
      'mngmntOfficeKeys', 'countryKeys', 'reportStatusKeys', 'mngmtCompanyKeys'
    ]),
    en() {
      return en
    },
    reportStatusKeyModify(){
      const renameMap = {
        new: 'NEW',
        open: 'OPEN'
      }

      return this.reportStatusKeys.map(v => ({
        ...v,
        name: renameMap[v.code] ?? v.name
      }))
    },
    dateRangeInspection: {
      get() {
        return this.filters.inspection_date || [null, null]
      },
      set(val) {
        this.filters.inspection_date = Array.isArray(val) && val.every(v => v === null) ? null : val
      }
    },
  },
  async created() {
    this.addRequestKeys([
      'getVesselKeys',
      'getFleetListKeys',
      'getReportStatusKeys',
      'getMngmtOfficeKeys',
      'getCountryListKeys',
      'getMngmtCompanyKeys',
      'getTimezoneKeys',
      'getEventOneKeys',
      'getEventImpactKeys',
      'getPortKeys',
    ]);
    const params = {};

    this.loading = true;

    await this.generateRequestKeys(params);
    await this.getRsReports(this.filters);

    this.loading = false;
  },
  // watch: {
  //   async 'filters.count'() {
  //     this.loading = true;
  //     await this.getRsReports(this.filters);
  //     this.loading = false;
  //   },
  //   async 'filters.category'(category){
  //     this.loading = true;
  //     this.filters.category = category;
  //     this.filters.page = 1
  //     this.loading = true
  //     await this.getRsReports(this.filters)
  //     this.loading = false
  //   },
  //   async 'filters.order_position'(position){
  //     this.loading = true;
  //     this.filters.order_position = position;
  //     this.loading = true
  //     await this.getRsReports(this.filters)
  //     this.loading = false
  //   }
  // }
}
</script>

<template>
  <div class="text-center">
    <div class="row no-gutters justify-content-between mb-1">
      <div class="col-sm-auto flex-grow-0">
        <h3 class="mb-0 text-left">Rightship Inspection List</h3>
      </div>
      <div class="col-sm-auto">
        <div class="row">
          <div class="col-sm-auto float-right pr-0" v-if="isAllowed('rightship.index.create') || isElite() || user.is_vessel === true">
            <button class="e-btn e-btn-green force-white-all" data-toggle="modal" data-target="#NewRsInspection">
              <font-awesome-icon icon="plus-square" style="width: 25px"/>
              <small class="font-weight-bold px-2">
                NEW RIGHTSHIP INSPECTION
              </small>
            </button>
          </div>
          <!--          <div class="col-sm-auto float-right pr-0">-->
          <!--            <button class="e-btn e-btn-blue force-white-all pr-3" data-toggle="modal" data-target="#ImportRsReportModal">-->
          <!--              <font-awesome-icon icon="plus-square" style="width: 25px"/>-->
          <!--              <small class="font-weight-bold">-->
          <!--                IMPORT-->
          <!--              </small>-->
          <!--            </button>-->
          <!--          </div>-->
          <!--          <div class="col-sm-auto float-right">-->
          <!--            <template>-->
          <!--              <div class="input-group">-->
          <!--                <button class="e-btn e-btn-blue-gray force-white-all">-->
          <!--                  <font-awesome-icon icon="file-excel" style="width: 20px"/>-->
          <!--                  <small class="font-weight-bold">-->
          <!--                    RIGHTSHIP INSPECTION TEMPLATE-->
          <!--                  </small>-->
          <!--                </button>-->
          <!--              </div>-->
          <!--            </template>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
    <div class="row no-gutters justify-content-between mb-1">
      <div class="col-sm-auto pb-2 mr-2">
        <nav aria-label="...">
          <ul class="pagination text-smallest mb-0 pb-0">
            <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
              <button class="page-link" @click="setPage(1)">First</button>
            </li>

            <li v-for="page in paginationPages" :key="page" class="page-item"
                :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
              <button class="page-link" @click="setPage(page)">{{ page }}</button>
            </li>

            <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
              <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-sm-auto" v-if="1==0">
        <div class="row mb-3 no-gutters justify-content-between align-items-center">
          <div class="col-md-auto">
            <label class="col-form-label pr-2 font-weight-bold">Filter By: </label>
          </div>
          <div class="col-md-auto px-1">
            <select name="" id="" class="form-inline form-control form-control-sm form-control-xs"
                    v-model="filters.fleet_id">
              <option :value="null">-- ALL FLEET --</option>
              <option :value="fleet.id" v-for="fleet in fleetKeys">{{ fleet.name ? fleet.name.toUpperCase() : '' }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-auto pb-2">
        <div class="input-group input-group-sm">
          <div class="input-group-prepend">
            <label class="input-group-text input-group-sm bg-white small border-0" for="rowCount"># of Row(s):</label>
          </div>
          <select class="form-control form-control-sm rounded-left" v-model="filters.count" id="rowCount">
            <option value="30">30</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="10000">All</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row no-gutters align-items-center justify-content-end">
      <div class="col-sm-auto">
        <div class="row mb-3 no-gutters justify-content-between align-items-center">
          <div class="col-md-auto px-1">
            <div class="float-right text-right ml-2 dropdown dropright" v-if="true">
              <button id="committeeReport" aria-expanded="false" aria-haspopup="true" class="mr-2 e-btn e-btn-primary force-white-all"
                      data-toggle="dropdown"
                      :disabled="reports.length === 0 || loading === true"
                      :class="reports.length === 0 || loading === true ? 'e-btn-blue-gray-disabled' : ''"
              >
                <font-awesome-icon class="mr-1" icon="download"/>
                Download
              </button>
              <div aria-labelledby="committeeReport" class="dropdown-menu">
                <button class="dropdown-item text-secondary font-weight-bolder" @click="downloadReport('excel')" type="button">
                  <font-awesome-icon icon="file-excel"/>
                  Excel
                </button>
                <button class="dropdown-item text-secondary font-weight-bolder" @click="downloadReport('pdf')" type="button">
                  <font-awesome-icon icon="file-pdf"/>
                  PDF
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row no-gutters" style="height: 75vh; overflow-y: auto">
      <div class="col-12">
        <table class="small e-tbl border-table">
          <thead class="bg-white" style="position: sticky; top: 0; z-index: 2">
          <tr>
            <th class="align-middle" style="width: 1em" scope="col">#</th>
            <th class="align-middle" scope="col" @click="sortByCategory('vessel_name')">
              <div class="white-space-no-wrap">
                VESSEL
                <span style="cursor: pointer" class="h6 ml-2">
                      <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'vessel_name'" class="sort-arrow-up"/>
                      <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'vessel_name'" class="sort-arrow-down"/>
                      <font-awesome-icon icon="sort" v-else/>
                    </span>
              </div>
            </th>
            <th class="align-middle" scope="col" @click="sortByCategory('manager_name')">
              <div class="white-space-no-wrap">
                MANAGER
                <span style="cursor: pointer" class="h6 ml-2">
                      <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'manager_name'" class="sort-arrow-up"/>
                      <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'manager_name'" class="sort-arrow-down"/>
                      <font-awesome-icon icon="sort" v-else/>
                    </span>
              </div>
            </th>
            <th class="align-middle" style="min-width: 25em" scope="col" @click="sortByCategory('title')">
              <div class="white-space-no-wrap">
                REPORT TITLE
                <span style="cursor: pointer" class="h6 ml-2">
                      <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'title'" class="sort-arrow-up"/>
                      <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'title'" class="sort-arrow-down"/>
                      <font-awesome-icon icon="sort" v-else/>
                    </span>
              </div>
            </th>
            <th class="align-middle" style="width: 5em" scope="col" @click="sortByCategory('report_status')">
              <div class="white-space-no-wrap">
                STATUS
                <span style="cursor: pointer" class="h6 ml-2">
                      <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'report_status'" class="sort-arrow-up"/>
                      <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'report_status'" class="sort-arrow-down"/>
                      <font-awesome-icon icon="sort" v-else/>
                    </span>
              </div>
            </th>
            <th class="align-middle" style="width: 5em" scope="col">LIST OF FINDINGS</th>
            <th class="align-middle" style="width: 5em" scope="col">FULL INSPECTION REPORT</th>
            <th class="align-middle" style="width: 5em" scope="col" @click="sortByCategory('non_conformity_count')">
              <div class="white-space-no-wrap">
                NO. OF FINDINGS
                <span style="cursor: pointer" class="h6 ml-2">
                      <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'non_conformity_count'" class="sort-arrow-up"/>
                      <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'non_conformity_count'" class="sort-arrow-down"/>
                      <font-awesome-icon icon="sort" v-else/>
                    </span>
              </div>
            </th>

            <th class="align-middle" style="width: 5em" scope="col" @click="sortByCategory('no_of_def')">
              <div class="white-space-no-wrap">
                NO. OF DEF
                <span style="cursor: pointer" class="h6 ml-2">
                      <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'no_of_def'" class="sort-arrow-up"/>
                      <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'no_of_def'" class="sort-arrow-down"/>
                      <font-awesome-icon icon="sort" v-else/>
                    </span>
              </div>
            </th>
            <th class="align-middle" style="width: 5em" scope="col" @click="sortByCategory('no_of_obs')">
              <div class="white-space-no-wrap">
                NO. OF OBS
                <span style="cursor: pointer" class="h6 ml-2">
                      <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'no_of_obs'" class="sort-arrow-up"/>
                      <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'no_of_obs'" class="sort-arrow-down"/>
                      <font-awesome-icon icon="sort" v-else/>
                    </span>
              </div>
            </th>
            <th class="align-middle" style="width: 5em" scope="col" @click="sortByCategory('no_of_rec')">
              <div class="white-space-no-wrap">
                NO. OF REC
                <span style="cursor: pointer" class="h6 ml-2">
                      <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'no_of_rec'" class="sort-arrow-up"/>
                      <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'no_of_rec'" class="sort-arrow-down"/>
                      <font-awesome-icon icon="sort" v-else/>
                    </span>
              </div>
            </th>
            <th class="align-middle" style="width: 11em" scope="col" @click="sortByCategory('fleet')">
              <div class="white-space-no-wrap">
                FLEET
                <span style="cursor: pointer" class="h6 ml-2">
                      <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'fleet'" class="sort-arrow-up"/>
                      <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'fleet'" class="sort-arrow-down"/>
                      <font-awesome-icon icon="sort" v-else/>
                    </span>
              </div>
            </th>
            <th class="align-middle" style="width: 11em" scope="col" @click="sortByCategory('port_name')">
              <div class="white-space-no-wrap">
                PORT
                <span style="cursor: pointer" class="h6 ml-2">
                      <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'port_name'" class="sort-arrow-up"/>
                      <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'port_name'" class="sort-arrow-down"/>
                      <font-awesome-icon icon="sort" v-else/>
                    </span>
              </div>
            </th>
            <th class="align-middle" style="width: 11em" scope="col" @click="sortByCategory('country')">
              <div class="white-space-no-wrap">
                COUNTRY
                <span style="cursor: pointer" class="h6 ml-2">
                      <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'country'" class="sort-arrow-up"/>
                      <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'country'" class="sort-arrow-down"/>
                      <font-awesome-icon icon="sort" v-else/>
                    </span>
              </div>
            </th>
            <th class="align-middle" style="min-width: 7em" scope="col" @click="sortByCategory('inspection_commencement_date')">
              <div class="white-space-no-wrap">
                DATE OF INSPECTION
                <span style="cursor: pointer" class="h6 ml-2">
                      <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'inspection_commencement_date'" class="sort-arrow-up"/>
                      <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'inspection_commencement_date'" class="sort-arrow-down"/>
                      <font-awesome-icon icon="sort" v-else/>
                    </span>
              </div>
            </th>
            <th class="align-middle" style="width: 12em" scope="col" @click="sortByCategory('inspector_name')">
              <div class="white-space-no-wrap">
                NAME OF INSPECTOR
                <span style="cursor: pointer" class="h6 ml-2">
                      <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'inspector_name'" class="sort-arrow-up"/>
                      <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'inspector_name'" class="sort-arrow-down"/>
                      <font-awesome-icon icon="sort" v-else/>
                    </span>
              </div>
            </th>
            <th class="align-middle" style="width: 15em" scope="col" @click="sortByCategory('company')">
              <div class="white-space-no-wrap">
                NAME OF COMPANY
                <span style="cursor: pointer" class="h6 ml-2">
                      <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'company'" class="sort-arrow-up"/>
                      <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'company'" class="sort-arrow-down"/>
                      <font-awesome-icon icon="sort" v-else/>
                    </span>
              </div>
            </th>
            <th class="align-middle" style="width: 15em" scope="col" @click="sortByCategory('responsible_person')">
              <div class="white-space-no-wrap">
                RESPONSIBLE
                <span style="cursor: pointer" class="h6 ml-2">
                      <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'responsible_person'" class="sort-arrow-up"/>
                      <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'responsible_person'" class="sort-arrow-down"/>
                      <font-awesome-icon icon="sort" v-else/>
                    </span>
              </div>
            </th>
            <th class="align-middle" style="width: 12em" scope="col" @click="sortByCategory('person_in_charge')">
              <div class="white-space-no-wrap">
                PERSON IN CHARGE
                <span style="cursor: pointer" class="h6 ml-2">
                      <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'person_in_charge'" class="sort-arrow-up"/>
                      <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'person_in_charge'" class="sort-arrow-down"/>
                      <font-awesome-icon icon="sort" v-else/>
                    </span>
              </div>
            </th>
            <th class="align-middle" style="width: 12em" scope="col" @click="sortByCategory('created_by')">
              <div class="white-space-no-wrap">
                CREATED BY
                <span style="cursor: pointer" class="h6 ml-2">
                      <font-awesome-icon icon="arrow-up" v-if="filters.order_position === 'asc' && filters.category === 'created_by'" class="sort-arrow-up"/>
                      <font-awesome-icon icon="arrow-down" v-else-if="filters.order_position === 'desc' && filters.category === 'created_by'" class="sort-arrow-down"/>
                      <font-awesome-icon icon="sort" v-else/>
                    </span>
              </div>
            </th>
            <th class="align-middle" style="width: 60px" scope="col">ACTION</th>
          </tr>
          <tr>
            <th></th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.vessel_name"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                style="width: 150px !important;"
                :isDisabled="loading"
              />
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.manager_name"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                style="width: 150px !important;"
                :isDisabled="loading"
              />
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.title"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                :isDisabled="loading"
              />
            </th>
            <th>
              <div class="d-flex align-items-center w-auto">
                <div class="input-group position-relative">
                  <select v-model="filters.report_status" class="form-control form-control-sm text-center" style="width: 160px;" @change="setVesselsToTable" :disabled="loading">
                    <option :value="null" :selected="true">-- ALL --</option>
                    <option v-for="(reportStatusKey, index) in reportStatusKeyModify" :key="index" :value="reportStatusKey.id">{{reportStatusKey.name}}</option>
                  </select>
                </div>
                <font-awesome-icon
                  class="ml-2"
                  icon="filter"
                  style="cursor: pointer;"
                  @click.prevent="setVesselsToTable"
                />
              </div>
            </th>
            <th></th>
            <th></th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.non_conformity_count"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                inputType="number"
                style="width: 90px !important;"
                :isDisabled="loading"
              />
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.no_of_def"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                inputType="number"
                style="width: 90px !important;"
                :isDisabled="loading"
              />
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.no_of_obs"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                inputType="number"
                style="width: 90px !important;"
                :isDisabled="loading"
              />
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.no_of_rec"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                inputType="number"
                style="width: 90px !important;"
                :isDisabled="loading"
              />
            </th>
            <th>
              <div class="d-flex align-items-center w-auto">
                <div class="input-group position-relative">
                  <select v-model="filters.fleet" class="form-control form-control-sm text-center" style="width: 130px;" @change="setVesselsToTable" :disabled="loading">
                    <option :value="null" :selected="true">-- ALL --</option>
                    <option v-for="(fleetKey, index) in fleetKeys.filter(fleet => fleet.name?.toUpperCase() !== 'N/A')" :key="index" :value="fleetKey.id">{{fleetKey.name}}</option>
                  </select>
                </div>
                <font-awesome-icon
                  class="ml-2"
                  icon="filter"
                  style="cursor: pointer;"
                  @click.prevent="setVesselsToTable"
                />
              </div>
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.port_name"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                style="width: 150px !important;"
                :isDisabled="loading"
              />
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.country"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                style="width: 150px !important;"
                :isDisabled="loading"
              />
            </th>
            <th>
              <div class="d-flex align-items-center w-auto">
                <div class="input-group position-relative">
                  <date-picker id = "date-picker" :lang="en" type="date" :style="{ width: '200px' }" valueType="format" range v-model="dateRangeInspection" @change="setVesselsToTable" lang="en" :disabled="loading"></date-picker>
                </div>
                <font-awesome-icon
                  class="ml-2"
                  icon="filter"
                  style="cursor: pointer;"
                  @click.prevent="setVesselsToTable"
                />
              </div>
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.inspector_name"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                style="width: 150px !important;"
                :isDisabled="loading"
              />
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.company"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                style="width: 150px !important;"
                :isDisabled="loading"
              />
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.responsible_person"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                style="width: 150px !important;"
                :isDisabled="loading"
              />
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.person_in_charge"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                style="width: 150px !important;"
                :isDisabled="loading"
              />
            </th>
            <th class="align-middle" style="background-color: rgb(225, 225, 225); cursor: pointer;" scope="col">
              <table-column-search
                v-model="filters.created_by"
                @callRequestFunction="setVesselsToTable"
                :x_button_z_index="9"
                style="width: 150px !important;"
                :isDisabled="loading"
              />
            </th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="loading">
            <td colspan="100%">
              <loading></loading>
            </td>
          </tr>
          <tr v-else-if="!reports.length && !loading">
            <td colspan="100%" class="text-center py-3">
              No records found.
            </td>
          </tr>
          <template v-else>
            <tr class="text-uppercase" v-for="(report, index) in reports" :key="report.id">
              <td>{{ index + pagination.from }}</td>
              <td>{{ report.vessel }}</td>
              <td>{{ report.manager }}</td>
              <td>{{ report.title }}</td>
              <td class="align-middle text-white" :class="['bg-'+report.report_status_color]">
                {{ report.report_status }}
              </td>
              <td>
                <template v-if="report.rsAttachment">
                  <font-awesome-icon icon="file-pdf" v-if="report.rsAttachment.has_file" @click="viewRsDownloadFile(report.rsAttachment,1,'view',report.id)" size="3x"
                                     class="force-danger-all" style="cursor: pointer">
                  </font-awesome-icon>
                  <font-awesome-icon icon="file-pdf" v-else  size="3x"></font-awesome-icon>
                </template>
              </td>
              <td>
                <template v-if="report.rsAttachmentFull">
                  <font-awesome-icon icon="file-pdf" v-if="report.rsAttachmentFull.has_file" @click="viewRsDownloadFile(report.rsAttachmentFull,6,'view',report.id)" size="3x"
                                     class="force-danger-all" style="cursor: pointer">
                  </font-awesome-icon>
                  <font-awesome-icon icon="file-pdf" v-else  size="3x"></font-awesome-icon>
                </template>
              </td>
              <td class="align-middle text-center"  style="cursor: pointer">
                <p class="py-0 my-0" :class="{'h5 text-danger': report.non_conformity_count > 0}" @click="viewListOfFindings(report)" data-toggle="modal" data-target="#viewListOfFindingsModal">
                {{ report.non_conformity_count }}</p></td>
              <td class="align-middle text-center"><p class="py-0 my-0" :class="{'h5 text-danger': report.no_of_def > 0}">
                {{ report.no_of_def }}</p></td>
              <td class="align-middle text-center"><p class="py-0 my-0" :class="{'h5 text-danger': report.no_of_obs > 0}">
                {{ report.no_of_obs }}</p></td>
              <td class="align-middle text-center"><p class="py-0 my-0" :class="{'h5 text-danger': report.no_of_rec > 0}">
                {{ report.no_of_rec }}</p></td>
              <td>{{ report.fleet }}</td>
              <td>{{ report.port }}</td>
              <td>{{ report.country }}</td>
              <td>{{ report.inspection_commencement_date }}</td>
              <td>{{ report.inspector }}</td>
              <td>{{ report.inspection_company }}</td>
              <td>{{ report.responsible_person }}</td>
              <td>{{ report.person_in_charge }}</td>
              <td>{{ report.created_by?.name }}</td>
              <td class="align-middle text-center">
                <div class="dropdown dropright my-1">
                  <button id="actionDropdown" aria-expanded="false" aria-haspopup="true"
                          class="btn btn-sm btn-secondary force-white-all" data-toggle="dropdown">
                    <font-awesome-icon icon="cogs"/>
                  </button>
                  <div aria-labelledby="actionDropdown" class="dropdown-menu py-0">
                    <button class="dropdown-item text-secondary font-weight-bolder"
                            v-if="isAllowed('rightship.index.view') || isElite()"
                            @click="showRsInspection(report.id)"
                            >
                      <font-awesome-icon icon="eye"/>
                      View
                    </button>
                    <button class="dropdown-item text-secondary font-weight-bolder"
                            v-if="isAllowed('rightship.index.view') || isElite()"
                            @click="showRsInspectionOnNewTab(report.id)"
                    >
                      <font-awesome-icon icon="eye"/>
                      View on New Tab
                    </button>
                    <button class="dropdown-item text-secondary font-weight-bolder text-danger"
                            v-if="user.is_vessel === false && ((isAllowed('rightship.index.delete') && report.report_status_id !== 1) || (user.id === report.created_by_id) || isElite())"
                            @click="verifyDelete(report)"
                            >
                      <font-awesome-icon icon="trash" class="force-danger-all"/>
                      Delete
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" id="viewListOfFindingsModal">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title mt-1 font-weight-bold">LIST OF FINDINGS</h5>
            <button type="button" class="close" @click="closeModal()" aria-label="Close" data-dismiss="modal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th width="40">#</th>
                      <th width="70">Code</th>
                      <th width="120">Type of Finding</th>
                      <th>Findings</th>
                      <th width="150">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                  <template v-for="(row, index) in listOfFindings">
                    <tr>
                      <td class="align-middle">{{index+1}}</td>
                      <td class="align-middle">{{row.rsn_question.code}}</td>
                      <td class="align-middle">{{row.type_of_finding}}</td>
                      <td class="align-middle">{{row.rsn_question.main_question}}</td>
                      <td class="align-middle text-uppercase" :class="row.report_status.report_status_id ? reportStatusInitial.filter(stat=>stat.id == row.report_status.report_status_id )[0].background : 'bg-42b983'">{{row.report_status.report_status_id ? reportStatusInitial.filter(stat=>stat.id == row.report_status.report_status_id )[0].name : 'NEW' }}</td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
<!--          <div class="modal-footer">-->
<!--            <button type="button" class="btn btn-secondary btn-sm" @click="closeModal()" data-dismiss="modal">Close</button>-->
<!--          </div>-->
        </div>
      </div>
    </div>

    <new-rs-inspection-report/>

  </div>
</template>

<style scoped>

::v-deep .border-table {
  border-collapse: separate;
  border-spacing: 0;
}

::v-deep .border-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;

  border-top: 1px solid #c3c3c3;
  border-bottom: 1px solid #c3c3c3;
  border-left: 1px solid #c3c3c3;
}

::v-deep .border-table thead th:last-child {
  border-right: 1px solid #c3c3c3;
}
</style>
